export default {
  title: 'Новий чат',
  form: {
    to: {
      label: 'Кому',
      placeholder: 'Введіть номер телефону',
    },
    from: {
      label: 'Від',
      placeholder: 'Обрати відправника',
    },
    message: {
      label: 'Повідомлення',
      placeholder: 'Введіть повідомлення...',
    },
    buttons: {
      close: 'Закрити',
      create: 'Створити',
    },
  },
}
